import { useEffect } from "react";
import type { GTM } from "../services/gtmEvent/GTMInterfaces";
import { sendGTMEvent } from "../services/gtmEvents";

interface GTMEventsComponentsProps {
  readonly events: GTM.EventExtendend[];
  readonly sender?: (event: GTM.Event) => void;
}

export function SendGtmEvents({ events, sender = sendGTMEvent }: GTMEventsComponentsProps): JSX.Element {
  useEffect(() => {
    events.forEach(sender);
  }, [events, sender]);

  return <></>;
}
